// Nebenknopf: die zweite Wahl neben einer Hauptaktion -- "Abbrechen", "Verwerfen",
// "Schliessen" als Text (ST-UX-001, NFR-UX-004).
//
// Immer secondary mit Rahmen und in der Groesse des Hauptknopfs daneben: so ist er
// als Knopf erkennbar und tritt doch hinter die eine Hauptaktion zurueck. Subtle
// bleiben nur Symbolknoepfe (Schliessen-X), Textlinks und Abschnittsaktionen am h2.
// Ein Baustein statt verstreuter appearance-Angaben, damit niemand "Verwerfen"
// wieder anders baut.

import type { ReactElement, Ref } from 'react';
import { Button, type ButtonProps } from '@fluentui/react-components';

/** Alles wie Fluent `Button`, nur `appearance` steht fest; `ref` reicht React 19 als Prop durch. */
export type NebenKnopfProps = Omit<ButtonProps, 'appearance'> & { readonly ref?: Ref<HTMLButtonElement> };

export function NebenKnopf(props: NebenKnopfProps): ReactElement {
  // ButtonProps ist eine Vereinigung aus Knopf und Verweis; ohne `as` bleibt es ein Knopf.
  return <Button {...(props as ButtonProps)} appearance="secondary" />;
}

/** "Abbrechen" als Nebenknopf: der Text steht fest, damit er ueberall gleich heisst. */
export function AbbrechenKnopf(props: Omit<NebenKnopfProps, 'children'>): ReactElement {
  return <NebenKnopf {...props}>Abbrechen</NebenKnopf>;
}
